import { angularJsApp } from "../app";
import { AppServicesEnum } from "../app.model";
import { IApiEnsenyaments, IApiSubetapa } from "./api.model";
import { NotificationsService } from "./notification.service";
import { SharedProperties } from "./share.service";

export class EnsenyamentsDataService {
  public ensenyaments: IApiSubetapa[] = [];
  public naturalesas: IApiSubetapa[] = [];
  public eduEspecial: IApiSubetapa[] = [];
  public serveisEducatius: IApiSubetapa[] = [];
  public tipusSuport: IApiSubetapa[] = [];
  private apiurl = `${this.SharedProperties.baseUrlService()}/MOE/services/ensenyaments/`;

  constructor(
    private SharedProperties: SharedProperties,
    private NotificationsService: NotificationsService,
    private $http: ng.IHttpService
  ) { }

  init(): ng.IPromise<IApiSubetapa[]> {
    return this.$http.get<IApiEnsenyaments>(`${this.apiurl}findAll?`, {})
      .then((response: any) => {
        this.ensenyaments = response.data.subetapas;
        return this.ensenyaments;
      })
      .catch(() => {
        this.NotificationsService.sendMessage("S'ha produit un error", "error");
        return this.ensenyaments;
      });
  }

  /**
   * Resets all properties and UI states.
   */
  reset(): void {
    document.querySelectorAll("div#cercaAvancada input[type='checkbox']:checked").forEach((el) => {
      (el as HTMLInputElement).checked = false;
    });
    this.resetRec(this.ensenyaments);
    this.resetRec(this.naturalesas);
    this.resetRec(this.tipusSuport);
    this.resetRec(this.eduEspecial);
    this.resetRec(this.serveisEducatius);
  }

  /**
   * Resets the `ensenyaments` array and UI elements.
   */
  resetEnsenyaments(): void {
    document.querySelectorAll("#ensenyaments input[type='checkbox']").forEach((el) => {
      (el as HTMLInputElement).checked = false;
    });
    this.resetRec(this.ensenyaments);
  }

  /**
   * Recursively resets all elements in a given array.
   * @param {any[]} _ensenyaments The array of elements to reset.
   */
  private resetRec(_ensenyaments: any[]): void {
    _ensenyaments.forEach((element) => {
      element.value = false;
      if (element.subnodes) {
        this.resetRec(element.subnodes);
      }
    });
  }

  /**
   * Generates a SQL filter string for `ensenyaments`.
   * @param {any[]} _ensenyaments The list of `ensenyaments` to filter.
   * @returns {string} The SQL filter string.
   */
  getEnsenyamentsFilter(_ensenyaments: any[]): string {
    const arrEnsenyaments: Record<string, string> = {};
    let filter = "(";

    _ensenyaments.forEach((element, i) => {
      const id = element.id;
      if (!arrEnsenyaments.hasOwnProperty(id)) {
        arrEnsenyaments[id] = id;
        if (i !== 0 && !isNaN(Number(id))) {
          filter += " OR ";
        }
        if (!isNaN(Number(id))) {
          filter += `E='${id}' `;
        }
      }
    });

    filter += ")";
    return filter;
  }

  getServeisEducatiusFilter(_serveisEducatius: any[]): string {
    var arrServeisEducatius = {};
    var filter = "(";
    _serveisEducatius.forEach((elemet, i) => {
      var id = elemet.id;
      if (!arrServeisEducatius.hasOwnProperty(id)) {
        arrServeisEducatius[id] = id;
        if (i != 0) {
          filter += " OR ";
        }
        filter += `SERVEI_ACRONIM='${id}' `;
      }
    });
    filter += ") ";
    if (filter == "()") {
      filter = "";
    }

    return filter;
  }


  /**
   * Generates a SQL list filter string for `ensenyaments`.
   * @param {any[]} elements The list of `ensenyaments` to filter.
   * @returns {string} The SQL list string.
   */
  getElementsSQLFilter(elements: IApiSubetapa[]): string {
    const arrEnsenyaments: Record<string, string> = {};
    
    return elements
      .filter((element) => !!element.id)
      .map((element, i) => {
        const id = element.id;
        if (!arrEnsenyaments.hasOwnProperty(id)) {
          arrEnsenyaments[id] = id;
          return i === 0 ? `'${id}'` : `, '${id}'`;
        }
        return "";
      })
      .join("");
  }

  getNaturalesasFilter(_naturalesas: any[], hasCursFilter = false): string {
    if (_naturalesas.length === 0) {
      return "";
    }

    const filter = _naturalesas
      .filter((element) => element?.codi != null)
      .map((element) => {
        if (!hasCursFilter || element.codi === "1") {
          return `NATURALESA='${element.codi}'`;
        }
        if (element.codi === "2") {
          return "( NATURALESA='2' OR ( NATURALESA='3' AND TE_SFP_CURS='N' ) )";
        }
        if (element.codi === "3") {
          return "( NATURALESA='3' AND TE_SFP_CURS='S' )";
        }
        return `NATURALESA='${element.codi}'`;
      })
      .join(" OR ");

    return filter ? `( ${filter} )` : "";
  }

  getSuportsFilter(_naturalesas: any[]): string {
    if (_naturalesas.length === 0) {
      return "";
    }

    const filter = _naturalesas
      .map((element, i) => {
        return `${i !== 0 ? " OR " : ""}SUPORT_ACRONIM='${element.codi}'`;
      })
      .join("");

    return `( ${filter} )`;
  }
}

angularJsApp.service(AppServicesEnum.ENSENYAMENTS_DATA_SERVICE, EnsenyamentsDataService);